import { PageHero } from "@/components/public/Layout";
import { Reveal, SectionLabel, ArchImage } from "@/components/public/shared";
import { useEnquiry } from "@/components/public/EnquiryProvider";
import { IMG } from "@/lib/images";
import { ShieldCheck, Repeat, Utensils, Building2 } from "lucide-react";

export default function FoodServices() {
  const { open } = useEnquiry();
  const targets = ["Offices", "Corporate Campuses", "Clubs", "Malls", "Institutions", "Managed Properties", "Employee Dining", "Recurring Meal Programs"];
  const caps = ["Daily Meal Programs", "Breakfast, Lunch & Dinner", "Snacks & Pantry Services", "Staff Meals", "Recurring Catering", "Contract Food Services", "Bulk Food Production", "Menu Flexibility"];
  const pillars = [
    { icon: ShieldCheck, t: "Hygiene & Quality", d: "Hygiene-first kitchens and consistent, dependable quality." },
    { icon: Repeat, t: "Operational Reliability", d: "Scheduled logistics and reliable recurring delivery." },
    { icon: Utensils, t: "Menu Flexibility", d: "Rotating pure-veg & Jain-Friendly menus your people look forward to." },
    { icon: Building2, t: "Scalable Teams", d: "Trained teams that scale with your organisation." },
  ];
  return (
    <div>
      <PageHero label="Bulk & Daily Food Services" title="Food services built around your organisation." subtitle="Recurring, high-volume pure vegetarian & Jain-Friendly food solutions for offices, clubs, malls and institutions." image={IMG.indianThali} />

      <section className="bg-ivory py-20 sm:py-28">
        <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
          <Reveal className="lg:col-span-5"><ArchImage src={IMG.corporate} alt="Corporate dining" ratio="aspect-[4/5]" /></Reveal>
          <Reveal className="lg:col-span-7" delay={120}>
            <SectionLabel>Who We Serve</SectionLabel>
            <h2 className="mt-5 font-display text-3xl font-light text-espresso sm:text-4xl">Mega-Scale Pure Vegetarian &amp; Jain-Friendly Food Solutions for Marriages, Corporate Offices, Clubs, IT Parks, Malls &amp; Institutions</h2>
            <div className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3">
              {targets.map((t) => <div key={t} className="text-sm text-espresso/90">— {t}</div>)}
            </div>
            <h3 className="mt-10 text-[11px] font-semibold uppercase tracking-editorial text-gold">Capabilities</h3>
            <div className="mt-4 grid grid-cols-2 gap-x-6 gap-y-3">
              {caps.map((c) => <div key={c} className="text-sm text-inkmuted">{c}</div>)}
            </div>
            <button data-testid="foodservices-discuss" onClick={() => open("bulk")} className="mt-10 inline-flex items-center gap-2 bg-espresso px-8 py-4 text-[12px] font-semibold uppercase tracking-editorial text-ivory transition-colors hover:bg-gold">
              Discuss Daily Food Services
            </button>
          </Reveal>
        </div>
      </section>

      <section className="bg-cream py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {pillars.map((p, i) => (
              <Reveal key={p.t} delay={i * 60}>
                <div className="h-full border border-subtle bg-ivory p-8">
                  <p.icon className="h-7 w-7 text-gold" />
                  <h3 className="mt-4 font-display text-xl text-espresso">{p.t}</h3>
                  <p className="mt-2 text-sm text-inkmuted">{p.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
